import Icon from '../components/Icon.vue'

Icon.register({"hdd":{"width":576,"height":512,"paths":[{"d":"M576 304V400C576 426.5 554.5 448 528 448H48C21.5 448 0 426.5 0 400V304C0 277.5 21.5 256 48 256H528C554.5 256 576 277.5 576 304zM528 224A79.6-79.6 0 0 0 558.8 230.2L462.3 85.4A48-48 0 0 1 422.3 64H153.7A48-48 0 0 1 113.8 85.4L17.2 230.2A79.6-79.6 0 0 0 48 224H528zM480 320C462.3 320 448 334.3 448 352S462.3 384 480 384 512 369.7 512 352 497.7 320 480 320zM384 320C366.3 320 352 334.3 352 352S366.3 384 384 384 416 369.7 416 352 401.7 320 384 320z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/hdd.js
// module id = null
// module chunks = 